{
  "version": 1,
  "asset_id": "bf776c4b-faec-4388-8cee-fdf3e6f30878",
  "project_id": "ede4779f-2e7a-461a-91d6-654024119c69",
  "url": "/__l5e/assets-v1/bf776c4b-faec-4388-8cee-fdf3e6f30878/sylwia-portret-osobisty.jpg",
  "r2_key": "a/v1/ede4779f-2e7a-461a-91d6-654024119c69/bf776c4b-faec-4388-8cee-fdf3e6f30878/sylwia-portret-osobisty.jpg",
  "original_filename": "sylwia-portret-osobisty.jpg",
  "size": 336188,
  "content_type": "image/jpeg",
  "created_at": "2026-09-14T17:48:04Z"
}
